import { useQuery } from '@apollo/client';
import { NotificationRole } from '@provision/entity-types';
import { useMemo } from 'react';
import { GET_NOTIFICATION_ROLE_QUERY } from 'src/graphql/entities/notification-preference/notifications.operations';
import { QueryVariables, Records } from 'src/graphql/types';

export type NotificationRoleResponse = Pick<
  NotificationRole,
  'id' | 'name' | 'category' | 'notificationRoleId'
>;

type GetNotificationRoleQuery = {
  getNotificationRole: Records<NotificationRoleResponse>;
};

export const useGetNotificationRoles = () => {
  const { data } = useQuery<GetNotificationRoleQuery, QueryVariables>(
    GET_NOTIFICATION_ROLE_QUERY,
  );
  const notificationRoles = useMemo(
    () => data?.getNotificationRole.records || [],
    [data?.getNotificationRole.records],
  );

  const notificationRolesMap = useMemo(
    () => new Map(data?.getNotificationRole.records.map((r) => [r.notificationRoleId, r])),
    [data?.getNotificationRole.records],
  );
  return {
    notificationRoles,
    notificationRolesMap,
  };
};
